/* eslint-disable eqeqeq */
import axios from "axios";
import qs from "qs";
import Crypto from "crypto-js";
import { SwAlert } from "../../components/Common/Alert/AlertForm";
import AxiosConfig, { currentLanguage, RedirectPath, useUnauthorize } from "./AxiosConfig";
import { AuthToken } from 'service/CommonFunction/AxiosConfig';
import secureLocalStorage from "react-secure-storage";


export const CheckResourceInjection = (sUrl: string) => {
    let Result = true;
    var r = new RegExp(/^(ftp|http|https):\/\/[^ "]+$/);
    Result = r.test(sUrl);
    return Result;
}

export const AlertTitle = {
    Success: currentLanguage() == "en" ? "Action Completed" : "สำเร็จ" ,
    Warning: currentLanguage() == "en" ? "Warning" : "แจ้งเตือน",
    Error: currentLanguage() == "en" ? "Error" : "เกิดข้อผิดพลาด",
    Info: currentLanguage() == "en" ? "Information" : "ข้อมูล",
    Confirm: currentLanguage() == "en" ? "Confirmation" : "ยืนยัน",
    Duplicate: currentLanguage() == "en" ? "Duplicate" : "ข้อมูลซ้ำกัน",
};

export const AlertTitleTh = {
    Success: "สำเร็จ",
    Warning: "แจ้งเตือน",
    Error: "เกิดข้อผิดพลาด",
    Info: "ข้อมูล",
    Confirm: "ยืนยัน",
    Hint: "Hint",
    Duplicate: "ข้อมูลซ้ำกัน",
};


export const AlertMsg = {
    SaveComplete: currentLanguage() == "en" ? "Data is already saved." : "บันทึกข้อมูลเรียบร้อย",
    DeleteComplete: currentLanguage() == "en" ? "Data is already deleted." : "ลบข้อมูลเรียบร้อยแล้ว",
    Warning: currentLanguage() == "en" ? "Warning" : "แจ้งเตือน",
    Error: currentLanguage() == "en" ? "Some thing went wrong" : "เกิดข้อผิดพลาด",
    Info: currentLanguage() == "en" ? "Info" : "ข้อมูล",
    confirm: currentLanguage() == "en" ? "Do you want to confirm ?" : "คุณต้องการที่จะยืนยันใช่หรือไม่ ?",
    confirmLogout: currentLanguage() == "en" ? "Do you want to log out ?" : "คุณต้องการออกจากระบบหรือไม่ ?",
    ConfirmSave: currentLanguage() == "en" ? "Do you want to save data ?" : "คุณต้องการที่จะบันทึกข้อมูลใช่หรือไม่ ?",
    ConfirmSaveDraft: currentLanguage() == "en" ? "Do you want to save draft data ?" : "คุณต้องการที่จะบันทึกร่างใช่หรือไม่ ?",
    ConfirmDelete: currentLanguage() == "en" ? "Do you want to delete data ?" : "คุณต้องการที่จะลบข้อมูลใช่หรือไม่ ?" ,
    ConfirmApprove: currentLanguage() == "en" ? "Do you want to approve data ?" : "คุณต้องการที่จะอนุมัติข้อมูลใช่หรือไม่ ?",
    ConfirmCancel: currentLanguage() == "en" ? "Do you want to cancel data ?" : "คุณต้องการที่จะยกเลิกข้อมูลใช่หรือไม่ ?",
    ConfirmReject: currentLanguage() == "en" ? "Do you want to reject data ?" : "คุณต้องการที่จะไม่อนุมัติข้อมูลใช่หรือไม่ ?",
    NoPermission: currentLanguage() == "en" ? "Access denied" : "การเข้าถึงถูกปฏิเสธ",
    SessionTimeOut: currentLanguage() == "en" ? "Please Log in " : "กรุณาเข้าสู่ระบบอีกครั้ง",
    Duplicate: currentLanguage() == "en" ? "Duplicate Data" : "ข้อมูลซ้ำกัน",
    UploadImage: currentLanguage() == "en" ? "Please upload" : "กรุณาอัพโหลด",
};

export const AlertMsgTh = {
    SaveComplete: "บันทึกข้อมูลเรียบร้อย",
    DeleteComplete: "ลบข้อมูลเรียบร้อยแล้ว",
    Warning: "แจ้งเตือน",
    Error: "เกิดข้อผิดพลาด",
    Info: "ข้อมูล",
    confirmLogout: "คุณต้องการออกจากระบบหรือไม่ ?",
    ConfirmSave: "คุณต้องการที่จะบันทึกข้อมูลใช่หรือไม่ ?",
    ConfirmSaveDraft: "คุณต้องการที่จะบันทึกร่างใช่หรือไม่ ?",
    ConfirmDelete: "คุณต้องการที่จะลบข้อมูลใช่หรือไม่ ?",
    ConfirmApprove: "คุณต้องการที่จะอนุมัติข้อมูลใช่หรือไม่",
    ConfirmCancel: "คุณต้องการที่จะยกเลิกข้อมูลใช่หรือไม่ ?",
    ConfirmReject: "คุณต้องการที่จะไม่อนุมัติข้อมูลใช่หรือไม่ ?",
    NoPermission: "การเข้าถึงถูกปฏิเสธ",
    SessionTimeOut: "กรุณาเข้าสู่ระบบอีกครั้ง",
    Duplicate: "ข้อมูลซ้ำกัน",
    UploadImage: "กรุณาอัพโหลด",
};

export const AxiosPost = async (
    sWebMetodName: string,
    objJSON: any,
    fnSuccess?: any,
    fnError?: any,
    fnComplete?: any,
    URLGBU?: boolean
) => {
    //Get Token from Controller

    const auth_token = AuthToken.get();

    let ConfigJwt = {
        Authorization: IsNullOrUndefined(auth_token) ? "" : `Bearer ${auth_token}`,
    };

    const newParam = sWebMetodName
    const baseUrl = process.env.REACT_APP_API_URL
    const sPathApi = `${baseUrl}api/${newParam}`
    const url = new URL(sPathApi, window.location.href);

    const sNewPath = url.origin + url.pathname + url.search;
    let currentPath = window.location.href;

    if (CheckResourceInjection(sNewPath)) {
        await axios
            .post(sNewPath, objJSON,
                { headers: ConfigJwt }
            )
            .then((res) => {
                switch (res.status) {
                    case 200:
                        if (fnSuccess) fnSuccess(res.data);
                        break;
                    case 401:
                        Unauthorize(currentPath);
                        break;
                    case 403:
                        NoPermission();
                        break;
                    case 404:
                        break;
                    case 423:
                        NoPermissionVOC(); 
                        break;
                    case 500:
                        ErrorInternalServer();
                        break;
                    default:
                        if (fnError) fnError(res.data);
                        break;
                }
            })
            .catch((errors) => {
                if (errors?.response?.status === 401) {
                    Unauthorize(currentPath);
                }
                else if (errors?.response?.status === 403) {
                    NoPermission();
                }
                else if (errors?.response?.status === 423) {
                    NoPermissionVOC(); 
                }
                if (fnError) {
                    fnError(errors);
                } else {
                    console.error(errors);
                }
            })
            .finally(() => {
                if (fnComplete) fnComplete();
            });
    }
};

export const AxiosBlobJson = async (path: any, data = {}) => {
    const response = await AxiosConfig.post(path, data, { responseType: "blob" });
    return response;

}

export const AxiosPostReport = async (
    sWebMetodName: string,
    objJSON: any,
    fnSuccess?: any,
    fnError?: any,
    fnComplete?: any
) => {
    let localJwtKey = process.env.REACT_APP_JWT_KEY as string;
    const auth_token = AuthToken.get();

    let ConfigJwt = {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Company-Token": `${localJwtKey}`,
        Authorization: IsNullOrUndefined(auth_token) ? "" : `Bearer ${auth_token}`,
    };

    // let sPathApi = process.env.REACT_APP_API_URL + "api/" + sWebMetodName;
    const newParam = sWebMetodName
    const baseUrl = process.env.REACT_APP_API_URL
    const sPathApi = `${baseUrl}api/${newParam}`
    const url = new URL(sPathApi, window.location.href);
    const sNewPath = url.origin + url.pathname + url.search;
    let currentPath = window.location.href;

    if (CheckResourceInjection(sNewPath)) {
        await axios
            .post(sNewPath, objJSON, { headers: ConfigJwt, responseType: "blob" })
            .then((res) => {
                switch (res.status) {
                    case 200:
                        if (fnSuccess) fnSuccess(res.data);
                        break;
                    case 401:
                        Unauthorize(currentPath);
                        break;
                    case 404:
                        break;
                        case 423:
                            NoPermissionVOC(); 
                            break;
                    case 500:
                        ErrorInternalServer();
                        break;
                    default:
                        if (fnError) fnError(res.data);
                        break;
                }
            })
            .catch((errors) => {
                if (errors?.response?.status === 401) {
                    Unauthorize(currentPath);
                }
                if (fnError) {
                    fnError(errors);
                } else {
                    console.error(errors);
                }
            })
            .finally(() => {
                if (fnComplete) fnComplete();
            });
    }
};

export const AxiosPostFileExcel = async (

    sWebMetodName: string,
    objJSON: any,
    fileName: string,
    fnSuccess?: any,
    fnError?: any,
    BlockUI?: any,
    UnBlockUI?: any
) => {
    let localJwtKey = process.env.REACT_APP_JWT_KEY as string;
    const auth_token = AuthToken.get();

    if (BlockUI) BlockUI();

    // let sUrl = process.env.REACT_APP_API_URL + "api/" + sWebMetodName;
    const newParam = sWebMetodName
    const baseUrl = process.env.REACT_APP_API_URL
    const sPathApi = `${baseUrl}api/${newParam}`
    const url = new URL(sPathApi, window.location.href);
    const sNewPath = url.origin + url.pathname + url.search;
    let currentPath = window.location.href;

    if (CheckResourceInjection(sNewPath)) {
        await axios({
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Company-Token": `${localJwtKey}`,
                Authorization: IsNullOrUndefined(auth_token) ? "" : `Bearer ${auth_token}`,
            },
            method: 'post',
            url: sNewPath,
            data: objJSON || {},
            responseType: "blob",
        }).then((res) => {
            var blob = new Blob([res.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const link = document.createElement("a");
            link.target = "_blank";
            var objectUrl = URL.createObjectURL(blob);
            link.href = objectUrl;
            link.setAttribute("download", fileName);
            link.setAttribute("visibility", "hidden");
            link.click();
            link.remove();
            if (fnSuccess) fnSuccess(res);
        }).catch((errors) => {
            // ResultAPI(errors, "");
            if (errors?.response?.status === 401) {
                Unauthorize(currentPath);
            } else if (fnError) {
                fnError(errors);
            }
        }).then((res) => {
            if (UnBlockUI) UnBlockUI();
        });
    }
};

export const AxiosGetAD = async (
    sWebMetodName: any,
    objJSON: any,
    fnSuccess?: any,
    fnError?: any,
    fnComplete?: any,
    sToken?: string,
) => {
    //Get Token from Controller
    let auth_token = sToken || null;

    let ConfigJwt = {
        Authorization: IsNullOrUndefined(auth_token) ? "" : `Bearer ${auth_token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
    };

    // let sPathApi = process.env.REACT_APP_API_URL + "api/" + sWebMetodName;
    const newParam = sWebMetodName
    const baseUrl = process.env.REACT_APP_API_URL
    const sPathApi = `${baseUrl}api/${newParam}`
    const url = new URL(sPathApi, window.location.href);
    const sNewPath = url.origin + url.pathname + url.search;
    let currentPath = window.location.href;

    if (CheckResourceInjection(sNewPath)) {
        await axios
            .get(sNewPath, {
                headers: ConfigJwt,
                params: objJSON,
                paramsSerializer: (params) => {
                    return qs.stringify(params);
                },
            })
            .then((res) => {

                switch (res.status) {
                    case 200:
                        if (fnSuccess) fnSuccess(res.data);
                        break;
                    case 401:
                        Unauthorize(currentPath);
                        break;
                    case 403:
                        NoPermission();
                        break;
                    case 404:
                        break;
                        case 423:
                        NoPermissionVOC(); 
                        break;
                    case 500:
                        ErrorInternalServer();
                        break;
                    default:
                        if (fnError) fnError(res.data);
                        break;
                }
            })
            .catch((errors) => {
                if (errors?.response?.status === 401) {
                    Unauthorize(currentPath);
                } else if (errors?.response?.status === 403) {
                    NoPermission();
                } else if (fnError) {
                    fnError(errors);
                }
            })
            .finally(() => {
                if (fnComplete) fnComplete();
            });
    }
};

export const AxiosGet = async (
    sWebMetodName: any,
    objJSON: any,
    fnSuccess?: any,
    fnError?: any,
    fnComplete?: any
) => {
    //Get Token from Controller
    const auth_token = AuthToken.get();

    let ConfigJwt = {
        Authorization: IsNullOrUndefined(auth_token) ? "" : `Bearer ${auth_token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
    };

    // let sPathApi = process.env.REACT_APP_API_URL + "api/" + sWebMetodName;
    const newParam = sWebMetodName
    const baseUrl = process.env.REACT_APP_API_URL
    const sPathApi = `${baseUrl}api/${newParam}`
    const url = new URL(sPathApi, window.location.href);
    const sNewPath = url.origin + url.pathname + url.search;

    let currentPath = window.location.href;
    if (CheckResourceInjection(sNewPath)) {
        await axios
            .get(sNewPath, {
                headers: ConfigJwt,
                params: objJSON,
                paramsSerializer: (params) => {
                    return qs.stringify(params);
                },
            })
            .then((res) => {

                switch (res.status) {
                    case 200:
                        if (fnSuccess) fnSuccess(res.data);
                        break;
                    case 401:
                        Unauthorize(currentPath);
                        break;
                    case 403:
                        NoPermission();
                        break;
                    case 404:
                        break;
                        case 423:
                        NoPermissionVOC(); 
                        break;
                    case 500:
                        ErrorInternalServer();
                        break;
                    default:
                        if (fnError) fnError(res.data);
                        break;
                }
            })
            .catch((errors) => {
                if (errors?.response?.status === 401) {
                    Unauthorize(currentPath);
                } else if (errors?.response?.status === 403) {
                    NoPermission();
                } 
                else if (errors?.response?.status === 423) {
                    NoPermissionVOC(); 
                }
                else if (fnError) {
                    fnError(errors);
                }
            })
            .finally(() => {
                if (fnComplete) fnComplete();
            });
    }
};

export const ResultAPI = (response: any, MSG_Success: string, fnOnSuccess?: any, fnOther?: any) => {
    let { status, Message } = response;
    if (status === 200) {
        if (fnOnSuccess) fnOnSuccess();
    } else if (status === 401) {
        let currentPath = window.location.href;
        Unauthorize(currentPath);
    } else if (status === 403) {
        
    } else if (status === 409) {
        let tempMsg = AlertTitle.Duplicate;
        if (!Message) {
            Message = tempMsg;
        }
    } else if (status === 423) {
        NoPermissionVOC();
    }
     else {
        if (fnOnSuccess) fnOnSuccess();
    }
};

export const OnFocus = (CtrlID1: string, CtrlID2: string) => {
    let CTRL1 = document.getElementById(CtrlID1);
    let CTRL2 = document.getElementById(CtrlID2);
    if (CTRL1) {
        CTRL1.addEventListener("keydown", function (e) {
            if (e.keyCode === 13) {
                if (CTRL2) {
                    CTRL2.click();
                    return false;
                }
            } else if (e.keyCode === 220) return false; //keyCode - BACKSLASH : 220
        });
    }
};

export const Unauthorize = (currentPath) => {
    let strUser = secureLocalStorage.getItem("sUserType") as string;

    if (useUnauthorize.get() != true) {
        useUnauthorize.set(true)
        SwAlert.Warning(AlertTitle.Warning, AlertMsg.SessionTimeOut, () => {
            // RedirectPath.set(currentPath);
            useUnauthorize.set(false)
            AuthToken.set("");
            if(strUser == "E")
            {
                //ให้ไป LoginAD
                onGotoLoginAD();
            }
            else
            {
                let anchor = document.createElement("a");
                anchor.href = "/Home";
                anchor.click();
            }
        });
    } else {
        useUnauthorize.set(false)
    }
};

const onGotoLoginAD =()=>{
    let sSiteAD = process.env.REACT_APP_LOGINAD;
    let anchor = document.createElement("a");
    anchor.href = sSiteAD;
    anchor.click();
}

export const NoPermission = () => {
    let useUn = useUnauthorize.get();
    
    if (useUn != true) {
        useUnauthorize.set(true)
        SwAlert.Warning(AlertTitle.Warning, AlertMsg.NoPermission, () => {
            useUnauthorize.set(false)
            let anchor = document.createElement("a");
            anchor.href = "/Home";
            anchor.click();
        });
    }
};

export const NoPermissionVOC = () => {
    SwAlert.Warning(AlertTitle.Warning, AlertMsg.NoPermission, () => {
        useUnauthorize.set(false)
        let anchor = document.createElement("a");
        anchor.href = "/Home";
        anchor.click();
    });
};

export const ErrorInternalServer = () => {
    SwAlert.Error(AlertTitleTh.Warning, "Status 500 : Internal Server Error", () => { });
};

export const IsNullOrUndefined = (Value: any) => {
    let Result = true;
    if (Value) {
        Result = false;
    }
    return Result;
};

export const ToInt = (Value: string) => {
    let Result = 0;
    if (Value) {
        Result = parseInt(Value);
    }
    return Result;
};

export function replaceDiacritics(s: any) {
    var diacritics = [
        /[\300-\306]/g, /[\340-\346]/g,  // A, a
        /[\310-\313]/g, /[\350-\353]/g,  // E, e
        /[\314-\317]/g, /[\354-\357]/g,  // I, i
        /[\322-\330]/g, /[\362-\370]/g,  // O, o
        /[\331-\334]/g, /[\371-\374]/g,  // U, u
        /[\321]/g, /[\361]/g, // N, n
        /[\307]/g, /[\347]/g, // C, c
    ];

    var chars = ['A', 'a', 'E', 'e', 'I', 'i', 'O', 'o', 'U', 'u', 'N', 'n', 'C', 'c'];

    for (var i = 0; i < diacritics.length; i++) {
        s = s.replace(diacritics[i], chars[i]);
    }

    return s
}

export const Extension = {
    Image: ["jpg", "jpeg", "png", "gif"],
    Video: ["mov", "wmv", "avi", "mp4"],
    PDF: ["pdf"],
    Document: ["doc", "docx", "xls", "xlsx", "txt"],
    Word: ["doc", "docx"],
    Excel: ["xls", "xlsx"],
    Powpoint: ["pptx", "pdf", "ppt"],
    txt: ["txt"],
    Email: ["msg"],
    Other: ["rar", "zip"],
    AllType: null,
    Image_New: ["jpg", "jpeg", "png"],
    Video_New: ["mp4"],

};

const keyCrypto = "P4ssw0rd3ndCr7pt"

export const Encrypt = (dataEncrypt: any) => {
    let data = dataEncrypt.toString();
    let result = Crypto.AES.encrypt(data, keyCrypto).toString();
    result = result.replace(/\//g, "s14sh").replace(/\+/g, "p1u5");

    return result;
};
export const Decrypt = (dataDecrypt: any) => {
    if (dataDecrypt && dataDecrypt != null && dataDecrypt != "null") {
        dataDecrypt = dataDecrypt.replace(/s14sh/g, "/").replace(/p1u5/g, "+");
        let bytes = Crypto.AES.decrypt(dataDecrypt, keyCrypto);
        let result = bytes.toString(Crypto.enc.Utf8);
        return result;
    } else {
        return "";
    }
};


